


















import { SfImage } from '@storefront-ui/vue';
import { computed, ref, defineComponent, PropType } from '@nuxtjs/composition-api';
import { Product } from '~/modules/catalog/product/types';
import { useUiHelpers } from '~/composables';

export default defineComponent({
  name: 'ProductManufacturerCategorySection',
  components: {
    SfImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
  },
  setup(props) {
    const { getCatLink } = useUiHelpers();
    return {
      getCatLink,
    };
  },
});
